// src/theme/tokens/elevation.js
// Faz 1 · 5-seviyeli yukseklik hiyerarsisi (Material 3 / Vercel modeli).
// Her seviye: shadow + bg overlay + (opsiyonel) border.
// Chakra semanticTokens.shadows araciligiyla expose edilir.

const elevation = {
  // ===== SHADOW TOKENS (semanticTokens.shadows altinda) =====
  shadows: {
    'elevation.0': { default: 'none', _dark: 'none' },
    'elevation.1': {
      default: '0 1px 2px 0 rgba(15, 20, 25, 0.04), 0 1px 3px 0 rgba(15, 20, 25, 0.06)',
      _dark:   '0 1px 2px 0 rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.04)',
    },
    'elevation.2': {
      default: '0 2px 4px -1px rgba(15, 20, 25, 0.06), 0 4px 8px -2px rgba(15, 20, 25, 0.08)',
      _dark:   '0 4px 8px -2px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.05)',
    },
    'elevation.3': {
      default: '0 4px 6px -2px rgba(15, 20, 25, 0.06), 0 12px 20px -4px rgba(15, 20, 25, 0.10)',
      _dark:   '0 8px 16px -4px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.06)',
    },
    'elevation.4': {
      default: '0 12px 24px -6px rgba(15, 20, 25, 0.12), 0 20px 40px -8px rgba(15, 20, 25, 0.10)',
      _dark:   '0 16px 32px -8px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(255, 255, 255, 0.07)',
    },
    'elevation.5': {
      default: '0 20px 40px -8px rgba(15, 20, 25, 0.18), 0 32px 60px -12px rgba(15, 20, 25, 0.14)',
      _dark:   '0 24px 48px -12px rgba(0, 0, 0, 0.85), 0 0 0 1px rgba(255, 255, 255, 0.08)',
    },
    // Glow varyantlari (interaktif vurgu)
    'elevation.glow.brand': {
      default: '0 0 0 1px var(--chakra-colors-brand-500_alpha_15), 0 8px 24px -4px var(--chakra-colors-brand-500_alpha_25)',
      _dark:   '0 0 0 1px var(--chakra-colors-brand-300_alpha_20), 0 12px 32px -6px var(--chakra-colors-brand-300_alpha_40)',
    },
    'elevation.glow.success': {
      default: '0 0 0 1px var(--chakra-colors-emerald-500_alpha_15), 0 8px 24px -4px var(--chakra-colors-emerald-500_alpha_25)',
      _dark:   '0 0 0 1px var(--chakra-colors-emerald-300_alpha_15), 0 12px 32px -6px var(--chakra-colors-emerald-300_alpha_30)',
    },
    'elevation.glow.danger': {
      default: '0 0 0 1px var(--chakra-colors-rose-500_alpha_15), 0 8px 24px -4px var(--chakra-colors-rose-500_alpha_25)',
      _dark:   '0 0 0 1px var(--chakra-colors-rose-300_alpha_15), 0 12px 32px -6px var(--chakra-colors-rose-300_alpha_30)',
    },
  },
  // ===== SURFACE TOKENS (her seviyenin onerilen bg/border'i) =====
  // Chakra semanticTokens.colors altinda expose edilir.
  surfaces: {
    'surface.0': { default: 'pageBackground',  _dark: 'pageBackground' },
    'surface.1': { default: 'whiteAlpha.800',  _dark: 'slate.850' },
    'surface.2': { default: 'whiteAlpha.900',  _dark: 'slate.800' },
    'surface.3': { default: 'white',           _dark: 'slate.750' },
    'surface.4': { default: 'white',           _dark: 'slate.700' },
    'surface.5': { default: 'white',           _dark: 'slate.700' },
    // Border eslesmeleri
    'surface.border.subtle':  { default: 'slate.100', _dark: 'slate.800' },
    'surface.border.default': { default: 'slate.200', _dark: 'slate.700' },
    'surface.border.strong':  { default: 'slate.300', _dark: 'slate.600' },
    'surface.border.accent':  { default: 'brand.500', _dark: 'brand.300' },
  },
};

export default elevation;
